import { render, staticRenderFns } from "./version-list.vue?vue&type=template&id=0f7db096"
import script from "./version-list.vue?vue&type=script&lang=js"
export * from "./version-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7db096')) {
      api.createRecord('0f7db096', component.options)
    } else {
      api.reload('0f7db096', component.options)
    }
    module.hot.accept("./version-list.vue?vue&type=template&id=0f7db096", function () {
      api.rerender('0f7db096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring-operation/version-list.vue"
export default component.exports